module.exports = "/_next/static/images/empresarialMobile-2b53e5a0e14f2b3afaf042fb1adde91a.svg";